module.exports = __webpack_public_path__ + "img/1_027.4887a6c3.jpg";